/**
 * API Configuration
 *
 * Central configuration for all API base URLs used across the application.
 *
 * SECURITY FIX: URLs are now sourced from environment variables with
 * hardcoded fallbacks. Create a .env file with:
 *   REACT_APP_API_URL=https://api.eleave.in/
 *   REACT_APP_IMAGE_URL=https://newapi.eleave.in/
 *
 * For local development, use .env.development:
 *   REACT_APP_API_URL=http://localhost:8888/Vidupu/Vidupu-API/
 */
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.eleave.in/';
export const IMAGE_URL = process.env.REACT_APP_IMAGE_URL || 'https://newapi.eleave.in/';
